<script setup>

// Components
import FooterContactdetails from '@/Components/Footer/FooterContactdetails.vue';
import FooterCopyright from '@/Components/Footer/FooterCopyright.vue';
import FooterOpeningHours from '@/Components/Footer/FooterOpeningHours.vue';
import FooterSocials from '@/Components/Footer/FooterSocials.vue';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const options = computed(() => usePage().props.template_options);
</script>

<template>
    <div
        :style="`color:${options.footer.text_color};background-color:${options.footer.background_color}`"
        class="relative overflow-hidden bg-gray-dark text-sm text-gray-light md:text-base"
    >
        <div class="container">
            <div class="py-12 md:py-16">
                <div class="md:flex md:gap-14">
                    <div class="md:w-4/12">
                        <FooterContactdetails />
                    </div>

                    <div class="md:w-4/12">
                        <FooterOpeningHours />
                    </div>

                    <div class="md:w-4/12">
                        <FooterSocials />
                    </div>
                </div>
            </div>
        </div>

        <FooterCopyright />
    </div>
</template>
